import component from './chart_doughnut.vue'
export default component
